module.exports = __webpack_public_path__ + "img/png.de71a53e.svg";